<app-modal-dialog title="Accept onboarding information" (dismiss)="cancel()">

    <main>
        <app-layout-row>
            <app-layout-column [width]="12">
                <p>This will accept the information provided by the partner and create a partner contact</p>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="6">
                <ul>
                    <li><b>Name:</b> {{partnerContact().Name.ContactName}}</li>
                    <li><b>Email:</b> {{partnerContact().Email.ContactEmail}}</li>
                    @if (partnerContact().PhoneNumber?.PhoneNumber) { <li><b>Phone:</b> {{partnerContact().PhoneNumber.PhoneNumber}}</li> }
                </ul>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="6">
                <app-multiselectbox 
                    name="contactTypes" 
                    caption="Contact types"
                    helpText="Select the contact types to be associated with this contact person."
                    [ngModel]="selectedContactTypeIds()"
                    [dataSource]="contactTypes()"
                    displayExpr="Name"
                    valueExpr="Id"
                    (valueChange)="selectedContactTypeIds.set($event)"
                    >
                </app-multiselectbox>
            </app-layout-column>
        </app-layout-row>
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary (buttonClick)="acceptAndCreate()">Accept and Create</app-button>
        <app-button secondary (buttonClick)="accept()">Accept - and create manually</app-button>
        <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>